// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/abs/views/home/component/left/components/menuPanel.less
// module id = 815
// module chunks = 42